import { render, staticRenderFns } from "./PelatihanPostTestReport.vue?vue&type=template&id=3cf337cf"
import script from "./PelatihanPostTestReport.vue?vue&type=script&lang=js"
export * from "./PelatihanPostTestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports